__turbopack_context__.v({
  "alertBox": "Create-module-scss-module__a2pBXq__alertBox",
  "form": "Create-module-scss-module__a2pBXq__form",
  "formActions": "Create-module-scss-module__a2pBXq__formActions",
  "formContent": "Create-module-scss-module__a2pBXq__formContent",
  "formError": "Create-module-scss-module__a2pBXq__formError",
  "formField": "Create-module-scss-module__a2pBXq__formField",
  "formFields": "Create-module-scss-module__a2pBXq__formFields",
  "formHeader": "Create-module-scss-module__a2pBXq__formHeader",
  "heading": "Create-module-scss-module__a2pBXq__heading",
  "headingDescription": "Create-module-scss-module__a2pBXq__headingDescription",
  "headingTitle": "Create-module-scss-module__a2pBXq__headingTitle",
  "iconWrapper": "Create-module-scss-module__a2pBXq__iconWrapper",
});
